import { logSystem } from 'logger';
import { transportRegistry } from '../Service';
const transport = {
    fire(r) {
        const ws = window.hcstatic.sitews;
        const returnResponseObject = r.returnResponseObject === true;
        const d = ws.send_jsonrpc(r.target, r.data, returnResponseObject);
        const promise = new Promise((resolve, reject) => {
            d.then((v) => {
                logSystem.debug(() => {
                    const strval = JSON.stringify(v);
                    const loglen = Math.min(strval.length, 200);
                    const ellipsis = loglen < strval.length ? '...' : '';
                    return `${r.target} => ${strval.slice(0, loglen)}${ellipsis}`;
                });
                resolve(v);
            }, (e) => {
                logSystem.error(`${r.target} !!!=>`, e);
                reject(e);
            });
        });
        return promise;
    }
};
transportRegistry.set('WEBSOCKET', transport);
